document.addEventListener("DOMContentLoaded", function() {
// Equalizer bars
  const eq = document.getElementById('equalizer');
  for (let i = 0; i < 90; i++) {
    const bar = document.createElement('div');
    bar.className = 'eq-bar';
    const minH = Math.floor(Math.random() * 14) + 4;
    const maxH = Math.floor(Math.random() * 110) + 30;
    const dur = (Math.random() * 1.0 + 0.5).toFixed(2);
    const delay = (Math.random() * 1.5).toFixed(2);
    bar.style.cssText = `--min-h:${minH}px;--max-h:${maxH}px;--d:${dur}s;--delay:${delay}s;animation-delay:${delay}s`;
    eq.appendChild(bar);
  }

  // Scroll reveal
  const reveals = document.querySelectorAll('.reveal');
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.08 });
  reveals.forEach(el => obs.observe(el));

  // Nav border on scroll
  const nav = document.querySelector('.max-motion-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.borderBottomColor = window.scrollY > 40 ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.06)';
    });
  }
});